import Vue from 'vue';
import { mapGetters } from 'vuex';
import globalTabs from '@/mixins/components/tabs';
import { refreshStates } from '@/mixins/refresh-states';
import StoreCurrency from './currency';
import StoreOrders from './orders';
import StorePayment from './payment';
import StoreBrand from './brand';
import StoreShipping from './shipping';
import StoreEmails from './emails';
import StoreDiscounts from './discounts';

export default Vue.component('data-product-store', {
  template: require('./template.html'),
  name: 'data-product-store',
  mixins: [refreshStates],
  computed: {
    ...mapGetters(['currentUser']),
  },
  components: {
    StoreCurrency,
    StoreOrders,
    StorePayment,
    StoreEmails,
    StoreBrand,
    StoreShipping,
    globalTabs,
  },
  data() {
    return {
      tabs: [],
      override: false,
    };
  },
  props: [
    'item-modal',
    'content',
    'active-item',
    'item-list',
    'all-categories',
  ],
  created() {
    this.getActiveTab();
    this.setTabs();
  },
  methods: {
    setTabs() {
      this.tabs = [{
        title: 'Orders',
        render: StoreOrders,
      }];
      // TODO: if collaborator?
      if (this.currentUser.owner) {
        this.tabs.push(
          {
            title: 'Payment',
            render: StorePayment,
          },
          {
            title: 'Currency',
            render: StoreCurrency,
          },
        );
      }
      this.tabs.push(
        {
          title: 'Shipping',
          render: StoreShipping,
        },
        {
          title: 'Brand',
          render: StoreBrand,
        },
        {
          title: 'Discounts',
          render: StoreDiscounts,
        },
        {
          title: 'Events',
          render: StoreEmails,
        },
      );
    },
    getActiveTab() {
      this.refreshState('storePayments', () => {
        this.override = 'Payment';
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/index.js